import { DatePicker } from "antd";
import dayjs from "dayjs";

type TheDateTimePickerProps = {
  onChange: (value: dayjs.Dayjs | null) => void;
  value: dayjs.Dayjs | null | undefined;
};


const TheDateTimePicker = (props: TheDateTimePickerProps) => {
  return <DatePicker variant="borderless" value={props.value} showTime onChange={props.onChange} allowClear={false} />;
};

export default TheDateTimePicker;